module.exports = __webpack_public_path__ + "img/credit-packs.bd5843ef.svg";